import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetPerformancePredicateState, getPerformancePredicate } from "../../../store/performancePredicate/action";
import { resetPerformanceScoreDetailState, getPerformanceScoreDetail as onGetPerformanceScoreDetails, addNewPerformanceScoreDetail as onAddNewPerformanceScoreDetail, updatePerformanceScoreDetail as onUpdatePerformanceScoreDetail, deletePerformanceScoreDetail as onDeletePerformanceScoreDetail, getPerformanceScoreDetailLoading } from "../../../store/performanceScoreDetail/action";
import { getPerformanceScore as onGetPerformanceScores, addNewPerformanceScore as onAddNewPerformanceScore, updatePerformanceScore as onUpdatePerformanceScore, deletePerformanceScore as onDeletePerformanceScore, getPerformanceScoreLoading, resetPerformanceScoreState } from "../../../store/performanceScore/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const PerformanceScore = () => {
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [companyName, setCompanyName] = useState({});
  const [clientName, setClientName] = useState({});
  const [detailList, setDetailList] = useState([]);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, performanceScores, isPerformanceScoreCreated, isPerformanceScoreSuccess, loading, error, performanceScoreDetails, performanceScoreDetailLoading, isPerformanceScoreDetailCreated, isPerformanceScoreDetailSuccess, companies, companyLoading, clientLoading, clients, performancePredicates, performancePredicateLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    performanceScores: state.PerformanceScore.performanceScores,
    isPerformanceScoreCreated: state.PerformanceScore.isPerformanceScoreCreated,
    isPerformanceScoreSuccess: state.PerformanceScore.isPerformanceScoreSuccess,
    loading: state.PerformanceScore.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    error: state.PerformanceScore.error,
    performanceScoreDetails: state.PerformanceScoreDetail.performanceScoreDetails,
    performanceScoreDetailLoading: state.PerformanceScoreDetail.loading,
    isPerformanceScoreDetailCreated: state.PerformanceScoreDetail.isPerformanceScoreDetailCreated,
    isPerformanceScoreDetailSuccess: state.PerformanceScoreDetail.isPerformanceScoreDetailSuccess,
    performancePredicates: state.PerformancePredicate.performancePredicates,
    performancePredicateLoading: state.PerformancePredicate.loading,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [performanceScoreList, setPerformanceScoreList] = useState([]);
  const [performanceScore, setPerformanceScore] = useState([]);
  const [scoreDetailAddedId, setScoreDetailAddedId] = useState(0);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [performanceScoreDetail, setPerformanceScoreDetail] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [performancePredicateList, setPerformancePredicateList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalDetail, setDeleteModalDetail] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [searchValueSecond, setSearchValueSecond] = useState([]);

  const defaultdate = () => {
    return moment(new Date()).format("YYYY/MM/DD HH:mm:ss").toString();
  };

  const onClickDelete = (performanceScore) => {
    setPerformanceScore(performanceScore);
    setDeleteModal(true);
  };

  const onClickDeleteDetail = (performanceScoreDetail) => {
    setPerformanceScoreDetail(performanceScoreDetail);
    setDeleteModalDetail(true);
  };

  const handleDeletePerformanceScore = () => {
    if (performanceScore) {
      dispatch(onDeletePerformanceScore(performanceScore));
      setDeleteModal(false);
    }
  };

  const handleDeletePerformanceScoreDetail = () => {
    if (performanceScoreDetail) {
      setScoreDetailAddedId(performanceScoreDetail.scoreId);
      dispatch(onDeletePerformanceScoreDetail(performanceScoreDetail));
      setDeleteModalDetail(false);
    }
  };

  const onClickApprove = (employee) => {
    setPerformanceScore(employee);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredPerformanceScores = performanceScores;
      if (type !== "all") {
        filteredPerformanceScores = performanceScores.filter((performanceScore) => performanceScore.kpips_status.name === type);
      }
      setPerformanceScoreList(filteredPerformanceScores);
    }
  };

  useEffect(() => {
    if (companySelected) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetPerformanceScoreState());
      dispatch(onGetPerformanceScores({ companyId: companySelected?.value ?? "" }));
    }
  }, [companySelected]);

  useEffect(() => {
    if (!isEmpty(performanceScores)) {
      setIsEdit(false);
      let filteredPerformanceScores = performanceScores;
      if (activeTypeTab !== "all") {
        filteredPerformanceScores = performanceScores.filter((performanceScore) => performanceScore.kpips_status.name === activeTypeTab);
      }
      setPerformanceScoreList(filteredPerformanceScores);
      let current = 0;
      if (scoreDetailAddedId !== 0) {
        performanceScores.forEach((obj, i) => {
          if (obj.id === scoreDetailAddedId) current = i;
        });
      }
      setInfo(performanceScores[current]);
    }
  }, [performanceScores, scoreDetailAddedId]);

  useEffect(() => {
    if (isPerformanceScoreDetailCreated) {
      dispatch(resetPerformanceScoreDetailState());
      dispatch(resetPerformanceScoreState());
      dispatch(onGetPerformanceScores());
    }
  }, [dispatch, isPerformanceScoreDetailCreated]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isSearch) {
      dispatch(resetPerformancePredicateState());
      dispatch(getPerformancePredicate());
    }
  }, [dispatch, performancePredicates, isSearch]);

  useEffect(() => {
    if (!isEmpty(performancePredicates)) {
      var data = [];
      var opt = [];
      performancePredicates.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPerformancePredicateList(data);
    }
  }, [performancePredicates]);

  const [filterDate, setFilterDate] = useState(null);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setPerformanceScore(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handlePerformanceScoreClick = useCallback(
    (arg) => {
      const data = arg;
      setPerformanceScore({
        id: data.id,
        name: data.name,
        company: {
          label: data.kpips_company.name,
          value: data.kpips_company.id,
        },
        client: {
          label: data.kpips_client.name,
          value: data.kpips_client.id,
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setPerformanceScoreDetail(null);
      setPerformanceScore(null);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const handlePerformanceScoreDetailClick = useCallback(
    (arg) => {
      const data = arg;

      setPerformanceScoreDetail({
        id: data.id,
        amount: data.amount,
        percentage_from: data.percentage_from,
        percentage_to: data.percentage_to,
        scoreId: data.scoreId,
        predicate: data.kpipsd_pp && {
          label: data.kpipsd_pp.name,
          value: data.kpipsd_pp.id,
        },
      });

      setIsEditDetail(true);
      toggleDetail();
    },
    [toggleDetail]
  );

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input type="checkbox" className="dataCheckbox form-check-input me-2" value={data.id} />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updatePerformancePredicate") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handlePerformanceScoreClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deletePerformancePredicate") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                  {data.statusId === 1 && (
                    <button
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : userRole && userRole.split(",").indexOf("approvePerformancePredicate") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : "btn-label btn btn-sm btn-soft-success fs-12 me-1 d-none"}
                      onClick={() => {
                        data.actionTitle = `Anda akan menyetujui tarif gaji untuk ${data.name}`;
                        onClickApprove(data);
                      }}
                    >
                      <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>APPROVE
                    </button>
                  )}
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Nama",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "kpips_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
    ],
    [handlePerformanceScoreClick, userType, userRole]
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: performanceScoreList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const columnsSecond = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input type="checkbox" className="dataCheckbox form-check-input me-2" value={data.id} />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updatePerformanceScore") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handlePerformanceScoreDetailClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deletePerformanceScore") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDeleteDetail(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Nama",
        accessor: "kpipsd_pp.name",
        filterable: true,
      },
      {
        Header: "% Value From",
        accessor: "percentage_from",
        filterable: true,
      },
      {
        Header: "% Value To",
        accessor: "percentage_to",
        filterable: true,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [info]
  );

  const {
    getTableProps: getTablePropsSecond,
    getTableBodyProps: getTableBodyPropsSecond,
    headerGroups: headerGroupsSecond,
    page: pageSecond,
    prepareRow: prepareRowSecond,
    canPreviousPage: canPreviousPageSecond,
    canNextPage: canNextPageSecond,
    pageOptions: pageOptionsSecond,
    gotoPage: gotoPageSecond,
    nextPage: nextPageSecond,
    previousPage: previousPageSecond,
    setPageSize: setPageSizeSecond,
    preGlobalFilteredRows: preGlobalFilteredRowsSecond,
    setGlobalFilter: setGlobalFilterSecond,
    state: { pageIndex: pageIndexSecond, pageSize: pageSizeSecond },
  } = useTable(
    {
      columns: columnsSecond,
      data: detailList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const onChangeInSelectSecond = (event) => {
    setPageSizeSecond(Number(event.target.value));
  };

  const onChangeInInputSecond = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPageSecond(page);
  };

  const onChangeSecond = useAsyncDebounce((value) => {
    setGlobalFilterSecond(value || undefined);
  }, 200);

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  const handleApproveScore = () => {
    if (performanceScore) {
      performanceScore.setApprove = true;
      dispatch(onUpdatePerformanceScore(performanceScore));
      setApproveModal(false);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (performanceScore && performanceScore.name) ?? "",
      client: (performanceScore && performanceScore.client) || clientSelected,
      company: (performanceScore && performanceScore.company) || companySelected,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Score Name").nullable(true),
      company: Yup.object().required("Please Enter Company").nullable(true),
      client: Yup.object().required("Please Enter Client").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getPerformanceScoreLoading());
      if (isEdit) {
        const updatePerformanceScore = {
          id: performanceScore ? performanceScore.id : 0,
          name: values.name,
          companyId: values.company.value,
          clientId: values.client.value,
          statusId: 2,
        };
        dispatch(onUpdatePerformanceScore(updatePerformanceScore));
        validation.resetForm();
      } else {
        const newPerformanceScore = {
          name: values.name,
          companyId: values.company.value,
          clientId: values.client.value,
          statusId: 2,
        };
        dispatch(onAddNewPerformanceScore(newPerformanceScore));
        validation.resetForm();
      }
      toggle();
    },
  });

  const validationDetail = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      scoreId: (performanceScoreDetail && performanceScoreDetail.scoreId) || (performanceScore && performanceScore.id),
      predicate: performanceScoreDetail && performanceScoreDetail.predicate,
      percentage_from: (performanceScoreDetail && performanceScoreDetail.percentage_from) || 0,
      percentage_to: (performanceScoreDetail && performanceScoreDetail.percentage_to) || 0,
    },
    validationSchema: Yup.object({
      predicate: Yup.object().required("Please Enter Predicate Value").nullable(true),
      percentage_from: Yup.string().required("Please Enter Percentage From").nullable(true),
      percentage_to: Yup.string().required("Please Enter Percentage To").nullable(true),
    }),
    onSubmit: (values) => {
      setScoreDetailAddedId(values.scoreId);
      dispatch(getPerformanceScoreLoading());
      if (isEditDetail) {
        const updatePerformanceScoreDetail = {
          id: performanceScoreDetail ? performanceScoreDetail.id : 0,
          predicateId: values.predicate.value,
          percentage_from: values.percentage_from,
          percentage_to: values.percentage_to,
          scoreId: values.scoreId,
        };
        dispatch(onUpdatePerformanceScoreDetail(updatePerformanceScoreDetail));
        validationDetail.resetForm();
      } else {
        const newPerformanceScoreDetail = {
          predicateId: values.predicate.value,
          percentage_from: values.percentage_from,
          percentage_to: values.percentage_to,
          scoreId: values.scoreId,
        };
        dispatch(onAddNewPerformanceScoreDetail(newPerformanceScoreDetail));
        validationDetail.resetForm();
      }
      toggleDetail();
    },
  });

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeletePerformanceScoreDetail(element.value));
    });
    checkall.checked = false;
  };

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetPerformanceScores(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setPerformanceScoreList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    dispatch(resetPerformanceScoreState());
    dispatch(onGetPerformanceScores({ companyId: companySelected?.value ?? "" }));
  };

  useEffect(() => {
    if (info && info.kpips_detail) {
      setDetailList(info.kpips_detail);
    }
  }, [info]);

  document.title = "Performance Score | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ApproveModal data={performanceScore && performanceScore.contract_employee ? performanceScore.contract_employee.name : ""} show={approveModal} onApproveClick={handleApproveScore} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeletePerformanceScore} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal show={deleteModalDetail} onDeleteClick={handleDeletePerformanceScoreDetail} onCloseClick={() => setDeleteModalDetail(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Guideline" pageTitle="Skor" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createPerformanceScore") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setPerformanceScore("");
                setIsEdit(false);
                toggle();
              }}
            >
              <i className=" ri-star-line me-1 align-bottom fs-14"></i>Tambah
            </button>
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={6}>
            <Card>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className=" ri-star-line me-1 align-bottom fs-14"></i>SEMUA SKOR
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i>DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={8}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Skor" : "Tambah Skor"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;{" "}
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                validation.setFieldValue("client", e);
                              }}
                              options={clientList}
                            ></Select>
                          </div>

                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;{" "}
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                dispatch(setBranchSelect(null));
                                dispatch(setCompanySelect(e));
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Nama
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Enter Score Name" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    {!!isEditDetail ? "Edit Score Detail" : "Add Score Detail"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationDetail.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3">
                          <Label htmlFor="predicate" className="form-label">
                            Predikat Value{" "}
                            {performancePredicateLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="predicate"
                            placeholder="Enter Predicate"
                            value={validationDetail.values.predicate}
                            onChange={(e) => {
                              validationDetail.setFieldValue("predicate", e);
                            }}
                            options={performancePredicateList}
                          ></Select>
                          {validationDetail.touched.predicate && validationDetail.errors.predicate ? (
                            <small className="text-danger" type="invalid">
                              {validationDetail.errors.predicate}
                            </small>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="percentage_from-field" className="form-label">
                            % From
                          </Label>
                          <Input name="percentage_from" id="percentage_from-field" className="form-control" placeholder="Enter Value From" type="number" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.percentage_from} invalid={validationDetail.touched.percentage_from && validationDetail.errors.percentage_from ? true : false} />
                          {validationDetail.touched.percentage_from && validationDetail.errors.percentage_from ? <FormFeedback type="invalid">{validationDetail.errors.percentage_from}</FormFeedback> : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="percentage_to-field" className="form-label">
                            % To
                          </Label>
                          <Input name="percentage_to" id="percentage_to-field" className="form-control" placeholder="Enter Value To" type="number" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.percentage_to} invalid={validationDetail.touched.percentage_to && validationDetail.errors.percentage_to ? true : false} />
                          {validationDetail.touched.percentage_to && validationDetail.errors.percentage_to ? <FormFeedback type="invalid">{validationDetail.errors.percentage_to}</FormFeedback> : null}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalDetail(false);
                          }}
                        >
                          Batal
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col xxl={6}>
            <Card>
              <div className="card-body d-flex align-items-center">
                <h5 className="text-uppercase mb-2 flex-grow-1">{info.name ? info.name : " - "}</h5>
                <div className="flex-shrink-0">
                  <button
                    type="button"
                    className={userType === "admin" ? "btn btn-success add-btn" : userRole && userRole.split(",").indexOf("createPerformanceScore") !== -1 ? "btn btn-success add-btn" : "btn btn-success add-btn d-none"}
                    id="create-btn"
                    onClick={() => {
                      setPerformanceScore(info);
                      setIsEditDetail(false);
                      toggleDetail();
                    }}
                  >
                    <i className="ri-list-check label-icon align-middle fs-13 me-1"></i>
                    Tambah Detail
                  </button>
                  <button className="btn btn-soft-danger" onClick={() => setDeleteModalMulti(true)}>
                    <i className="ri-delete-bin-5-line me-1 align-bottom fs-13"></i>
                  </button>
                </div>
              </div>
              <div className="card-body">
                <Row>
                  <CardBody className="border border-top-0 border-end-0 border-start-0">
                    <form>
                      <Row>
                        <Col sm={2}>
                          <div className="me-2 mb-2">
                            <select className="form-select" value={pageSizeSecond} onChange={onChangeInSelectSecond}>
                              {[10, 50, 100, 250, 500].map((pageSizeSecond) => (
                                <option key={pageSizeSecond} value={pageSizeSecond}>
                                  {pageSizeSecond}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={4}>
                          <div className="search-box me-2 mb-2 d-inline-block col-12">
                            <input
                              onChange={(e) => {
                                setSearchValueSecond(e.target.value);
                                onChangeSecond(e.target.value);
                              }}
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              placeholder={`Cari...`}
                              value={searchValueSecond ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Row>
                <div className="table-responsive table-card mb-1">
                  <Table hover {...getTablePropsSecond()} className="align-middle table-nowrap">
                    <thead className="table-light">
                      {headerGroupsSecond.map((headerGroup, index) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                          {headerGroup.headers.map((column, index) => (
                            <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                              {column.render("Header")}
                              {generateSortingIndicator(column)}
                              {/* <Filter column={column} /> */}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>

                    <tbody {...getTableBodyPropsSecond()}>
                      {pageSecond.map((row) => {
                        prepareRowSecond(row);
                        return (
                          <Fragment key={row.getRowProps().key}>
                            <tr>
                              {row.cells.map((cell, index) => {
                                return (
                                  <td {...cell.getCellProps()} key={index}>
                                    {cell.render("Cell")}
                                  </td>
                                );
                              })}
                            </tr>
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                  <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button color="light" onClick={previousPageSecond} disabled={!canPreviousPageSecond}>
                        {"<"}
                      </Button>
                    </div>
                  </Col>
                  <Col className="col-md-auto d-none d-md-block">
                    Halaman {pageIndex + 1} dari {pageOptions.length}
                  </Col>
                  <Col className="col-md-auto">
                    <Input type="number" min={1} style={{ width: 70 }} max={pageOptionsSecond.length} defaultValue={pageIndexSecond + 1} onChange={onChangeInInputSecond} />
                  </Col>
                  <Col className="col-md-auto">
                    <div className="d-flex gap-1">
                      <Button className="btn btn-light" onClick={nextPageSecond} disabled={!canNextPageSecond}>
                        {">"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PerformanceScore;
